export default __webpack_public_path__ + "static/media/Mark-5-Suit-02.293a4171.jpg";